<template>
  <div>
    <CallCenterTabs></CallCenterTabs>
  </div>
</template>

<script>
import CallCenterTabs from "@/components/tabs.vue";

export default {
  name: "v-administer",
  components: {
    CallCenterTabs
  }
};
</script>
